import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { EXTERNAL_ROLE_OPTIONS } from "~/constants/dropdowns/RoleOptions";
import Select from "./SelectWrapper/Select";

const AGENT_OPTION = EXTERNAL_ROLE_OPTIONS.find((o) => o.value === "agent");
const AFFILIATE_OPTION = EXTERNAL_ROLE_OPTIONS.find(
  (o) => o.value === "affiliate",
);
const RECRUITING_OPTION = { value: "recruiting", label: "Recruiting" };
const ARCHIVE_OPTION = { value: "archived", label: "Archive" };

const ROLE_SWITCH_MAP = {
  agent: AFFILIATE_OPTION,
  affiliate: AGENT_OPTION,
};

const getOptions = (role, lead) => {
  const roleOption = role ? ROLE_SWITCH_MAP[role.name] : null;

  const leadOptions = lead
    ? [
        ...(lead.retention ? [RECRUITING_OPTION] : []),
        ...(lead.archived ? [] : [ARCHIVE_OPTION]),
      ]
    : [RECRUITING_OPTION, ARCHIVE_OPTION];

  return [roleOption, ...leadOptions].filter(Boolean);
};

const LeadBucketAndRoleSelect = ({
  role = null,
  lead = null,
  placeholder = "Move to ...",
  onChange = () => false,
  ...restProps
}) => {
  const options = useMemo(() => getOptions(role, lead), [role, lead]);

  return (
    <Select
      placeholder={placeholder}
      value={null}
      onChange={onChange}
      options={options}
      isSearchable={false}
      {...restProps}
    />
  );
};

LeadBucketAndRoleSelect.propTypes = {
  role: PropTypes.shape({
    name: PropTypes.string,
  }),
  lead: PropTypes.shape({
    retention: PropTypes.bool,
    archived: PropTypes.bool,
  }),
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

export default LeadBucketAndRoleSelect;
